import http from '../http.js'

/**
 * 后端校验 Cloudflare Turnstile token
 * @param {{ turnstile_token: string }} data
 */
export const verifyTurnstile = (data) => {
  return http.post('/api/aigc/pre_interface/cloudflare/verify', {
    turnstile_token: data.turnstile_token,
  })
}
